module.exports = __webpack_public_path__ + "media/images/pc/stores/shibuya/shibuya_concept_01-dfbc12836f260d6d77672155f63aaa69.jpg";